import { Dialog, DialogContent, DialogTitle, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid2';

import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';

import { useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from "react";
import validaRut from "../../../../utils/validaRut";
import { useToast } from "../../../../hooks/useToast";
import { format } from "rut.js";
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { StatusCode } from "../../../../utils/enums";
import { AxiosResponse } from "axios";
import { createInmobiliaria, updateInmobiliaria } from "../service/servicesInmobiliarias";
import { getCurrentUsername } from '../../../../services/userRolesService';




interface InmobiliariaFormProps {
    show: boolean
    dataediting?: InmobiliariaWriteDto | undefined
    onHide: () => void
    refresh: () => void
    // setisloading: (loading: boolean) => void
    // setrefresh: (value: boolean) => void
    convenios: OptionType[]
}

type OptionType = { label: string; value: string; title: string }

export interface InmobiliariaWriteDto {
    id: number;
    rut: string;
    nombre: string;
    rutHolding: string;
    nombreHolding: string;
    convenioId?: number;
    nombreUsuario: string;
}

const InmobiliariaForm: React.FC<InmobiliariaFormProps> = (props) => {
    const currentUsername = getCurrentUsername();

    const validationSchema = yup.object().shape({
        id: yup.number().default(0),
        rut: yup.string().default('').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
            return validaRut.rutFormat(value);
        }).required('Requerido'),
        nombre: yup.string().default('').nonNullable().required('Requerido').max(30, 'Máximo 30 caractéres'),
        convenioId: yup.number().test('valida-convenio', 'Requerido', function (value) { return value! > 0; }),
        rutHolding: yup.string().default('')
            .test('valida-rut', 'RUT inválido', function (value) {
                return validaRut.rutFormat(value);
            })
            .when(["nombreHolding"], {
                is: (nombreHolding: string) => { return nombreHolding; },
                then: (s) => s.required('Requerido'),
                otherwise: (s) => s.notRequired()
            }),
        nombreHolding: yup.string().default('')
            .max(100, 'Máximo 100 caractéres')
            .when(["rutHolding"], {
                is: (rutHolding: string) => { return rutHolding; },
                then: (s) => s.required('Requerido'),
                otherwise: (s) => s.notRequired()
            }),
        nombreUsuario: yup.string().default(currentUsername).nonNullable().required()
    },
        [
            ["rutHolding", "nombreHolding"]
        ]
    )

    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
    } = useForm({ resolver: yupResolver(validationSchema) })

    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
    const { addToast } = useToast();


    const onSubmit = (data: InmobiliariaWriteDto) => saveInmobiliaria(data)

    useEffect(() => {
        reset()
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (props.dataediting) {
            setValue('id', props.dataediting['id'])
            setValue('rut', props.dataediting['rut'])
            setValue('nombre', props.dataediting['nombre'])
            setValue('rutHolding', props.dataediting['rutHolding'])
            setValue('nombreHolding', props.dataediting['nombreHolding'])
            setValue('convenioId', props.dataediting['convenioId'] ? props.dataediting['convenioId'] : 0);
        } else {
            reset()
        }
    }, [props.dataediting])

    function customOnHide() {
        reset()
        props.onHide()
    }


    async function saveInmobiliaria(data: InmobiliariaWriteDto) {

        // props.setisloading(true)

        data.rut = format(data.rut, { dots: false })

        if (data.rutHolding)
            data.rutHolding = format(data.rutHolding, { dots: false })

        const response: AxiosResponse = props.dataediting ? await updateInmobiliaria(data) : await createInmobiliaria(data);

        if (response.status === StatusCode.NoContent || response.status === StatusCode.Created) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: !props.dataediting
                    ? 'Inmobiliaria creada correctamente'
                    : 'Inmobiliaria guardada correctamente'
            });

            // props.setrefresh(true)
            setIsSubmitSuccessful(true)

            reset();
            props.refresh();
            props.onHide();
        }
        // props.setisloading(false)
    }

    return (

        <Dialog
            open={props.show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>{props.dataediting ? 'Editar inmobiliaria' : 'Nueva inmobiliaria'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <input
                        {...register('id')}
                        type="hidden"
                        value={(props.dataediting && props.dataediting['id']) || (0)}
                    />
                    <input
                        {...register('nombreUsuario')}
                        type="hidden"
                        value={(props.dataediting && props.dataediting['nombreUsuario']) || currentUsername}
                    />

                    <Grid container spacing={2}>
                        <Grid size={3}>
                            <InputRut name="rut" control={control} readonly={props.dataediting != null} label='RUT' />
                            <FormHelperText error> {errors?.rut?.message} </FormHelperText>
                        </Grid>
                        <Grid size={6}>
                            <InputText name="nombre" control={control} label="Nombre" />
                            <FormHelperText error> {errors?.nombre?.message} </FormHelperText>
                        </Grid>
                        <Grid size={3}>
                            <InputSelect
                                name="convenioId"
                                control={control}
                                options={props.convenios}
                                label="Convenio asociado"
                            />
                            <FormHelperText error> {errors?.convenioId?.message} </FormHelperText>
                        </Grid>
                        <Grid size={3}>
                            <InputRut name="rutHolding" control={control} label='RUT holding' />
                            <FormHelperText error> {errors?.rutHolding?.message} </FormHelperText>
                        </Grid>
                        <Grid size={9}>
                            <InputText name="nombreHolding" control={control} label="Nombre holding" />
                            <FormHelperText error> {errors?.nombreHolding?.message} </FormHelperText>
                        </Grid>
                    </Grid>

                    <Grid container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                        <Grid>
                            <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                        </Grid>
                        <Grid>
                            <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                        </Grid>
                    </Grid>

                </form>
            </DialogContent>
        </Dialog>

    )
}

export default InmobiliariaForm